import {
    GET_WEBCHAT,
    GET_WEBCHAT_FAILED,
    GET_WEBCHAT_SUCCESS,
} from './constants';

/**
 * Create an action of type GET_WEBCHAT
 *
 * @export {function} getWebchat
 * @returns {Object} - Action of type GET_WEBCHAT
 */
export function getWebchat () {
    return {
        type: GET_WEBCHAT,
    };
}

/**
 * Create an action of type GET_WEBCHAT_SUCCESS
 *
 * @export {function} getWebchatSuccess
 * @returns {Object} - Action of type GET_WEBCHAT_SUCCESS and the API data payload
 */
export function getWebchatSuccess (response) {
    return {
        type: GET_WEBCHAT_SUCCESS,
        response,
    };
}

/**
 * Create an action of type GET_WEBCHAT_FAILED
 *
 * @export {function} getWebchatFailed
 * @returns {Object} - Action of type GET_WEBCHAT_FAILED and the API data payload
 */
export function getWebchatFailed (error, errorCode) {
    return {
        type: GET_WEBCHAT_FAILED,
        error,
        errorCode,
    };
}
